



















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { getCookie, setCookie } from '../util/cookies.js'

declare global {
  interface Window { adsbygoogle: any[] }
}

const noop = () => undefined

@Component({
  props: {
    storyType: String,
  },
})
export default class ListStories extends Vue {
  time = ''
  loaded = false
  rendered = false
  newestStoryISODate = this.localeISODateString(new Date().getTime() / 1000)
  storySource = getCookie('news.hackerer.storySource', 'topstories')
  loSort = getCookie('news.hackerer.loSort', true)
  hiSort = getCookie('news.hackerer.hiSort', false)

  mounted() {
    this.tick()
    this.loadStoryIds()
  }

  sortTitle(day, col) {
    if (this.storySource === 'askshow') {
      return col === 0 ? 'Ask HN' : 'Show HN'
    } else if (this.storySource === 'newstories') {
      if (day === 0) {
        if (col === 0) {
          return 'Newest'
        } else {
          return this.hiSort ? 'Recent' : 'Recent Popular'
        }
      } else {
        return col === 0 ? 'Newish' : 'Warm'
      }
    } else {
      return col === 0 ? 'Niche' : 'General'
    }
  }

  toggleFilterDate() {
    if (this.$store.filterDate === 'today') {
      this.$store.filterDate = 'yesterday'
    } else if (this.$store.filterDate === 'yesterday') {
      this.$store.filterDate = 'older'
    } else {
      this.$store.filterDate = 'today'
    }

    this.storySource = 'topstories'
    setCookie('news.hackerer.storySource', this.storySource)
    if (this.countStories() === 0) {
      this.loadStoryIds()
    }
  }

  toggleStorySource() {
    if (this.storySource === 'topstories') {
      return
    }
    const oldStorySource = this.storySource
    if (this.storySource === 'topstories') {
      this.storySource = 'newstories'
    } else if (this.storySource === 'newstories') {
      this.storySource = 'askshow'
    } else {
      this.storySource = 'topstories'
    }
    setCookie('news.hackerer.storySource', this.storySource)
    if (this.countStories() === 0) {
      this.loadStoryIds()
    }
  }
  toggleSort(day, col) {
    if (day) {
      return
    }
    if (col === 0) {
      this.loSort = !this.loSort
      setCookie('news.hackerer.loSort', this.loSort)
    } else {
      this.hiSort = !this.hiSort
      setCookie('news.hackerer.hiSort', this.hiSort)
    }
  }
  titleText(story) {
    return story.type === 'story' ? story.title : `${story.type}: ${story.title}`
  }
  linkTitle(story) {
    return (story.url || '').replace(/^https?:\/\//, '').replace('www.', '')
      .replace(/#[^#]*$/, '').replace(/\.html?/, '').replace(/\/$/, '')
  }
  itemDomain(story) {
    return (story.url || '').replace(/^https?:\/\/(?:www\.)?([^/]*).*/, '$1')
  }
  itemLink(story) {
    return `https://news.ycombinator.com/item?id=${story.id}`
  }
  titleLink(story) {
    return story.url || `https://news.ycombinator.com/item?id=${story.id}`
  }
  domainLink(story) {
    const domain = this.itemDomain(story)
    return domain && `https://news.ycombinator.com/from?site=${domain}`
  }

  colStories(stories, day) {
    if (stories.length === 0) {
      return []
    }
    const newestUnixTime = Math.max.apply(null, stories.map(s => s.time))
    const newestStoryISODate = this.localeISODateString(newestUnixTime)
    const scored = stories.sort((a, b) => a.score === b.score ? b.time - a.time : a.score - b.score)
    let lo: any[]
    let hi: any[]
    if (this.storySource === 'askshow') {
      lo = scored.filter(s => !s.url && !s.title.startsWith('Show HN') && s.title.startsWith('Launch HN'))
      hi = scored.filter(s => s.url || s.title.startsWith('Show HN') || s.title.startsWith('Launch HN'))
    } else {
      lo = []
      hi = []
      const domains = this.mainstreamDomainRegex()
      const excepts = this.exceptionDomainRegex()
      for (const story of scored) {
        if (story.url && story.url.match(domains) && !story.url.match(excepts)) {
          hi.push(story)
        } else {
          lo.push(story)
        }
      }
    }

    if (day === 0) {
      if (this.loSort || this.storySource === 'newstories') {
        lo.sort((a, b) => b.time - a.time)
      } else {
        lo.reverse()
      }
      if (this.hiSort) {
        hi.sort((a, b) => b.time - a.time)
      } else {
        hi.reverse()
      }

      if (newestStoryISODate !== this.newestStoryISODate) {
        this.newestStoryISODate = newestStoryISODate
        this.tick()
      }
    } else {
      lo.reverse()
      hi.reverse()
    }

    // if (lo.length === hi.length) {
    //   zipped.push([undefined, undefined])
    // }
    return [lo, hi]
  }

  mainstreamDomainRegex() {
    const domains = [
      'nytimes.com',
      'medium.com',
      'techcrunch.com',
      'bbc.co.uk',
      'bbc.com',
      'washingtonpost.com',
      'guardian.co.uk',
      'theguardian.com',
      'plus.google.com',
      'wired.com',
      'bloomberg.com',
      'google.com',
      'wsj.com',
      'youtube.com',
      'youtu.be',
      'reddit.com',
      'apple.com',
      'twitter.com',
      'reuters.com',
      'facebook.com',
      'cnn.com',
      'zdnet.com',
      'arstechnica.com',
      'hbr.org',
      'wikipedia.org',
      'independent.co.uk',
      'businessinsider.in',
      'businessinsider.com',
      'newstatesman.com',
      'cnet.com',
      'ccn.com',
      'slate.com',
      'spectator.co.uk',
      'mercurynews.com',
      'theregister.co.uk',
      'scientificamerican.com',
      'observer.com',
      'technologyreview.com',
      'nautil.us',
      'nationalgeographic.com',
      'buzzfeednews.com',
      'boingboing.net',
      'thehustle.co',
      'news.gallup.com',
      'vancouversun.com',
      'inc.com',
      'theverge.com',
      'sfchronicle.com',
      'aeon.co',
      'thehill.com',
      'qz.com',
      'scitechdaily.com',
      'theatlantic.com',
      'vice.com',
      'dev.to',
      'scienceabc.com',
      'hackernoon.com',
      'infoq.com',
      'nature.com',
      'gizmondo.com',
      'newatlas.com',
      'linkedin.com',
      'extremetech.com',
      'rollingstone.com',
      'indiehackers.com',
      'abs-cbn.com',
      'businesswire.com',
      'thenextweb.com',
      'slashdot.org',
      'newyorker.com',
      'sciencemag.org',
      'cbc.ca',
      'phoronix.com',
      'thedailybeast.com',
      'rawstory.com',
      'computerworld.com',
      'vox.com',
      'news.com.au',
      'newrepublic.com',
      'appleinsider.com',
      'indiatimes.com',
      'foreignpolicy.com',
      'torrentfreak.com',
      'theconversation.com',
      'fastcompany.com',
      'brainpickings.org',
      'nejm.org',
    ]
    return new RegExp(domains.join('|').replace('.', '\\.'), 'gi')
  }

  exceptionDomainRegex() {
    const domains = [
      '.nautil.us',
    ]
    return new RegExp(domains.join('|').replace('.', '\\.'), 'gi')
  }

  countStories() {
    if (this.storySource === 'askshow') {
      return this.$store.askStories.length + this.$store.showStories.length
    } else if (this.storySource === 'newstories') {
      return this.$store.newStories.length
    } else {
      return this.$store.topStories.length
    }
  }

  tagStoriesByDate() {
    const now = new Date()
    let stories = this.storiesFromSource()

    if (this.$store.filterDate) {
      const utcSeconds = Math.floor(now.getTime() / 1000)

      if (this.$store.filterDate === 'today') {
        const minTime = utcSeconds - Math.min(Math.max(utcSeconds % 86400, 8 * 3600), 12 * 3600)
        stories = stories.filter(s => s.time && s.time >= minTime)
      } else if (this.$store.filterDate === 'yesterday') {
        const minTime = utcSeconds - Math.min(Math.max(utcSeconds % 86400, 8 * 3600), 12 * 3600) - 86400
        const maxTime = utcSeconds - Math.min(Math.max(utcSeconds % 86400, 8 * 3600), 12 * 3600)
        stories = stories.filter(s => s.time && s.time >= minTime && s.time <= maxTime)
      } else {
        const maxTime = utcSeconds - Math.min(Math.max(utcSeconds % 86400, 8 * 3600), 12 * 3600) - 86400
        stories = stories.filter(s => s.time && s.time <= maxTime)
      }
    }

    let storyDate = now
    if (stories.length !== 0) {
      storyDate = new Date(stories[0].time * 1000)
    }
    if (this.loaded) {
      if (stories.length === 0) {
        stories.push({
          id: -1,
          type: 'story',
          time: Math.floor(now.getTime() / 1000),
          score: '',
          title: 'No top stories yet for today. Click the date heading for yesterday\'s stories.',
        })
      } else if (stories.length <= 12 && stories[stories.length - 1].id !== -1) {
        stories.push({
          id: -1,
          type: 'story',
          time: Math.floor(now.getTime() / 1000),
          score: '',
          title: 'Not many top stories yet for today. Click the date heading for yesterday\'s stories.',
          url: 'https://',
        })
      }
    }
    return [{
      date: now,
      dateString: this.shortDate(storyDate),
      tagStories: this.tagStories(stories),
    }]
  }

  storiesByDate() {
    const stories = this.storiesFromSource()
    const dates: any[] = []
    const byDate = {}
    const dateString = {}
    for (const story of stories) {
      const date = this.localeISODateString(story.time)
      const dayStories = byDate[date] || []
      if (dayStories.length === 0) {
        byDate[date] = dayStories
        dates.push(date)
        dateString[date] = this.shortDate(new Date(story.time * 1000))
      }
      dayStories.push(story)
    }
    dates.sort()
    dates.reverse()

    const storiesByDate: any[] = []
    for (const d of dates) {
      storiesByDate.push({ date: d, dateString: dateString[d], stories: byDate[d] })
    }
    return storiesByDate
  }

  storiesFromSource() {
    let stories: any[] = []
    if (this.storySource === 'askshow') {
      stories = this.$store.askStories.concat(this.$store.showStories)
      const askShowIds = stories.map(s => s.id)
      const newAskShow = this.$store.newStories.filter(
        s => (!s.url || s.title.startsWith('Show HN') || s.title.startsWith('Launch HN')) && !askShowIds.includes(s.id))
      stories = stories.concat(newAskShow)
    } else if (this.storySource === 'newstories') {
      stories = this.$store.newStories
    } else {
      stories = this.$store.topStories
    }
    return stories
  }

  addStory(story, stories) {
    switch (story.type) {
      case 'story': {
        stories.push(story)
        break
      }
      case 'comment': {
        this.$store.comments[story.id] = story
        break
      }
      case 'job':
      case 'poll': {
        stories.push(story)
        break
      }
      case 'pollopt': {
        break
      }
      default: {
        break
      }
    }
  }

  loadStoryIds() {
    const urlStories: any[] = []
    if (this.storySource === 'askshow') {
      urlStories.push([`https://hacker-news.firebaseio.com/v0/askstories.json`, this.$store.askStories])
      urlStories.push([`https://hacker-news.firebaseio.com/v0/showstories.json`, this.$store.showStories])
      if (this.$store.newStories.length === 0) {
        urlStories.push([`https://hacker-news.firebaseio.com/v0/newstories.json`, this.$store.newStories])
      }
    } else if (this.storySource === 'newstories') {
      if (this.$store.newStories.length === 0) {
        urlStories.push([`https://hacker-news.firebaseio.com/v0/newstories.json`, this.$store.newStories])
      }
    } else {
      urlStories.push([`https://hacker-news.firebaseio.com/v0/topstories.json`, this.$store.topStories])
    }
    for (const [url, store] of urlStories) {
      this.getUrl(url, (status, responseText) => {
        if (status === 200 && responseText) {
          const storyIds = JSON.parse(responseText)
          storyIds.sort((a, b) => b - a)
          this.loadStories(storyIds, store).then(noop)
        }
      })
    }
  }

  async loadStories(storyIds, store) {
    store.length = 0

    this.loaded = false
    this.rendered = false
    const result = {remaining: storyIds.length, stories: []}
    let i = 0
    for (const id of storyIds) {
      i++
      if (i % 10 === 0) {
        await this.sleep(200)
      }
      this.loadStory(id, result, store)
    }
  }

  loadStory(storyId, result, store) {
    this.getStoryUrl(storyId, `https://hacker-news.firebaseio.com/v0/item/${storyId}.json`,
    (status, responseText) => {
      if (status === 200 && responseText) {
        const story = JSON.parse(responseText)
        if (story) {
          this.addStory(story, result.stories)
        }
      }
      result.remaining--
      let batchSize = 60
      const total = store.length + result.stories.length
      if (total < 140) {
        batchSize = 10
      } else if (total < 200) {
        batchSize = 20
      }
      if (result.remaining % batchSize === 0) {
        for (const story of result.stories) {
          store.push(story)
        }
        result.stories.length = 0
        if (result.remaining === 0) {
          this.loaded = true
        }
      }
    })
  }

  tagStories(stories) {
    const tagStories = {}
    for (const story of stories) {
      const tag = this.tagStory(story)
      let nameStories = tagStories[tag]
      if (!nameStories) {
        nameStories = []
        tagStories[tag] = nameStories
      }
      nameStories.push(story)
    }
    const orderedStories = this.$store.tags.flatMap(tagNameRegex => {
      const { name, regex } = tagNameRegex
      const nameStories = tagStories[name]
      return nameStories ? [{ tag: name, stories: nameStories }] : []
    })
    if (tagStories['']) {
      orderedStories.unshift({ tag: '', stories: tagStories[''] })
    }
    return orderedStories
  }

  tagStory(story) {
    const showLaunchHN = story.title.startsWith('Show HN') || story.title.startsWith('Launch HN')
    if (this.storySource === 'askshow' || !story.url || showLaunchHN) {
      return story.url || showLaunchHN ? 'Show HN' : 'Ask HN'
    }
    for (const tag of this.$store.tags) {
      const { name, type, regex } = tag
      if (type === 'domain') {
        if (regex.test(this.itemDomain(story))) {
          return name
        }
      } else {
        if (regex.test(this.titleText(story))) {
          return name
        }
      }
    }
    return ''
  }

  getStoryUrl(storyId, url, onLoad) {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.onload = () => {
      onLoad(xhr.status, xhr.responseText)
    }
    xhr.send()
  }

  getUrl(url, onLoad) {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.onload = () => {
      onLoad(xhr.status, xhr.responseText)
    }
    xhr.send()
  }

  tick() {
    const d = new Date()
    let time = d.toLocaleTimeString().replace(/:[0-5][0-9] /, ' ').toLowerCase()
    const date = this.localeISODateString(d.getTime() / 1000)
    if (date !== this.newestStoryISODate) {
      time = this.shortDate(d) + ' ' + time
    }
    this.time = time
    setTimeout(this.tick, 1 + (60 - d.getSeconds()) * 1000)
  }

  currentTime(day) {
    return day === 0 ? this.time : ''
  }
  shortDate(d) {
    return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })
  }

  localeISODateString(unixTime) {
    const d = new Date(unixTime * 1000)
    const mm = 1 + d.getMonth() < 10 ? `0${1 + d.getMonth()}` : `${1 + d.getMonth()}`
    const dd = d.getDate() < 10 ? `0${d.getDate()}` : `${d.getDate()}`
    const s = `${d.getFullYear()}-${mm}-${dd}`
    return s
  }

  async sleep(millis) {
    return new Promise( resolve => setTimeout(resolve, millis) )
  }
}
